/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()
  // const [userType, setUserType] = useState(false)
  function checkEnterpriseAdmin() {
    let check_admin = localStorage.getItem('kt-auth-react-v') || ''
    let adminObj = JSON.parse(check_admin)
    console.log('isEnterpriseAccount: ' + adminObj.isEnterpriseAccount)
    if (adminObj.isEnterpriseAccount === 'YES') {
      localStorage.setItem('user_type', 'EnterpriseAccount')
    }
  }

  useEffect(() => {
    // let user_type = localStorage.getItem('user_type')
    // if (user_type === 'Super Admin') {
    //   setUserType(true)
    // }

    checkEnterpriseAdmin()
  }, [])
  let userType = localStorage.getItem('user_type')
  return userType === 'Super Admin' ? (
    // super Admin
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='\media\svg\general\dashboard.svg'
        title={intl.formatMessage({id: 'MENU.HOME'})}
        fontIcon='las la-tint text-white'
      />

      <SidebarMenuItem
        to='/super_admin_user'
        icon='\media\svg\general\invoice.svg'
        title='Account'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/super_admin_property'
        icon='\media\svg\general\test.svg'
        title='Property'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/approve_kyc'
        icon='/media\svg\general\file-check.svg'
        title='Approve KYC'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/estamp_request'
        icon='/media\svg\general\file-check.svg'
        title='eStamp Request'
        fontIcon='bi-app-indicator'
      />
    </>
  ) : //EnterpriseAccount login
  localStorage.getItem('user_type') === 'EnterpriseAccount' ? (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='\media\svg\general\dashboard.svg'
        title={intl.formatMessage({id: 'MENU.HOME'})}
        fontIcon='bi bi-house-door'
      />

      {/* <SidebarMenuItem
        to='enterprise_User_Home'
        icon='/media/icons/duotune/art/art002.svg'
        title='Users'
        fontIcon='bi-app-indicator'
      /> */}

      <SidebarMenuItem
        to='/property?page=1'
        icon='\media\svg\general\test.svg'
        title='Property'
        fontIcon='bi-app-indicator'
      />

      {/* <SidebarMenuItem
        to='/team'
        icon='/media/icons/duotune/art/art002.svg'
        title='Team'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='/media/icons/duotune/general/gen051.svg'
        title='User management'
        fontIcon='bi-layers'
      /> */}
      {/* <SidebarMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      />
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
        />
        <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Onboard' hasBullet={true}>
        </SidebarMenuItem>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
    */}
    </>
  ) : (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='\media\svg\general\dashboard.svg'
        title={intl.formatMessage({id: 'MENU.HOME'})}
        fontIcon=''
      />
      {userType === 'Non-Tenant' && (
        <>
          <SidebarMenuItem
            to='/property?page=1'
            icon='\media\svg\general\test.svg'
            title='Properties'
            fontIcon='bi-app-indicator'
          />
          {/* <SidebarMenuItem
            to='/invoices'
            icon='/media\svg\general\invoice.svg'
            title='Invoices'
            fontIcon='bi-app-indicator'
          /> */}
          <SidebarMenuItem
            to='/KYC_Details'
            icon='/media\svg\general\file-check.svg'
            title='KYC Details'
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/tickets'
            icon='/media\svg\general\ticket.svg'
            title='Tickets'
            fontIcon='bi-app-indicator'
          />
           <SidebarMenuItem
            to='/create_agreement'
            icon='/media\svg\general\document.svg'
            title='Create Agreement'
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/lead_management'
            icon='/media\svg\general\starfill.svg'
            title='Lead Management'
            fontIcon='bi-app-indicator'
          />
           <SidebarMenuItem
            to='/analytics'
            icon='\media\svg\general\analytics.svg'
            title='Analytics'
            fontIcon='bi-app-indicator'
          />
          {/* <SidebarMenuItem
            to='/ticket_dashboard'
            icon='/media\svg\general\ticket.svg'
            title='Ticket Dashboard'
            fontIcon='bi-app-indicator'
          /> */}
        </>
      )}
      {userType === 'Tenant' && (
        <>
          <SidebarMenuItem
            to='/rented-properties'
            icon='\media\svg\general\test.svg'
            title='Rented properties'
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/tickets'
            icon='/media\svg\general\ticket.svg'
            title='Tickets'
            fontIcon='bi-app-indicator'
          />
        </>
      )}
    </>
  )
}

export {SidebarMenuMain}
